import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';

const Banner = ({ bannerImage, logo, smallTitle, subtitle, buttonText, textColour, linkTo }) => (
	<div className='rs-banner banner-home-style2 home-style2'>
		<BuilderImage
			className='banner-image'
			src={bannerImage.image}
			alt={bannerImage.alt}
		/>
		<div className='container container-fluid2' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
			<div className='content-wrap' style={{ padding: '0 0 20px 0' }}>
				{logo && (
					<h2 className='title'>
						<img
							className='banner-logo'
							src={logo}
							alt='CommCon logo'
							loading='eager'
							placeholder='none'
						/>
					</h2>
				)}

				{smallTitle && (
					<h2
						className='small-title'
						style={{ color: textColour }}
					>
						{smallTitle}
					</h2>
				)}

				{subtitle && subtitle !== '<p><br></p>' && (
					<div
						className='sub-title new'
						style={{ color: textColour }}
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
				)}

				{buttonText && (
					<div className='btn-part new'>
						<a className='readon btn-text ticket orange-btn' href={linkTo}>
							<span>
								{buttonText}
							</span>
						</a>
					</div>
				)}
			</div>
		</div>
	</div>
);

export default Banner;
